<template>
  <div class="item">
    <NuxtImg
      :src="`/images/roles/why-proxify/${item.icon}.svg`"
      alt="carousel-icon"
    />
    <p class="title">{{ item.title }}</p>
    <p class="description">{{ item.description }}</p>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style lang="scss" scoped>
@import './Item.scss';
</style>
